import { graphql } from '@apollo/client/react/hoc';
import { flowRight as compose } from 'lodash';

import AllocatorProfileShowPageQuery from 'buyside/graphql/queries/AllocatorProfileShowPage';
import UpdateAllocatorProfileBackgroundImageMutation from 'buyside/graphql/mutations/UpdateAllocatorProfileBackgroundImage';
import UpdateAllocatorProfileMutation from 'buyside/graphql/mutations/UpdateAllocatorProfile';

import AllocatorProfileShowPage from 'buyside/components/presentation/AllocatorProfileShowPage/allocatorProfileShowPage';

const withData = graphql(AllocatorProfileShowPageQuery, {
  props({ data: { loading, currentUser, allocatorProfile } }) {
    return { loading, currentUser, allocatorProfile };
  },
  options: ({ allocatorProfileId }) => ({ variables: { allocatorProfileId } })
});

const withUpdateBackgroundImage = graphql(UpdateAllocatorProfileBackgroundImageMutation, {
  props: ({ mutate, ownProps: { allocatorProfileId } }) => ({
    updateBackgroundImage: ({ cropData, imageData, removeImage }) => {
      return mutate({
        variables: {
          allocatorProfileId,
          imageData,
          cropData: JSON.stringify(cropData),
          removeImage: removeImage
        }
      });
    }
  })
});

const withUpdateAllocatorProfile = graphql(UpdateAllocatorProfileMutation, {
  props: ({ mutate }) => ({
    updateAllocatorProfile: ({ allocatorProfile, section }) => {
      const {
        aumRange,
        employerType,
        location,
        fundManager,
        bio,
        executives,
        investmentCriteria
      } = allocatorProfile;
      return mutate({
        variables: {
          allocatorProfileId: allocatorProfile.id,
          section,
          aumRange,
          employerType,
          location,
          fundManager,
          bio,
          executives: JSON.stringify(executives),
          investmentCriteria
        }
      });
    }
  })
});

const AllocatorProfileShowPageContainer = compose(
  withData,
  withUpdateBackgroundImage,
  withUpdateAllocatorProfile
)(AllocatorProfileShowPage);

export default AllocatorProfileShowPageContainer;
